import { Component, Input } from '@angular/core';


@Component({
    selector: 'similar',
    templateUrl: './similar.component.html',
    styleUrls: ['./similar.component.scss']
})
export class SimilarComponent {

    @Input() info : any;

    similarAds: any = [
        {
          name: 'La Martina Residencial',
          image: 'https://i0.wp.com/www.dallo.com.br/wp-content/uploads/dallo-la-martina-la-martina-3-1920x0-c-default.jpg',
        }, {
          name: 'Noah Residencial',
          image: 'https://i0.wp.com/www.dallo.com.br/wp-content/uploads/dallo-noah-noah-3-1920x0-c-default.jpg',
        }, {
          name: 'Cadenza Residencial',
          image: 'https://i0.wp.com/www.dallo.com.br/wp-content/uploads/dallo-cadenza-cadenza-10-1920x0-c-default.jpg',
        }
      ];

    constructor( 
    ){
    }

}